<se-fe-card class="commerce-list-card" id="catalog-list">
  <se-fe-card-header seFeDataTitle="Catalogs" [seFeDataDivider]="true">
    <div seFeCardHeaderActions>
      <app-create-catalog #createCatalogModal></app-create-catalog>
      <app-delete-catalog-modal #deleteCatalogModal></app-delete-catalog-modal>
    </div>
  </se-fe-card-header>

  <se-fe-card-content>
    <se-fe-grid seFeGridOpts>
      <se-fe-grid-cell seFeGridOpts>
        <app-catalog-table
          [catalogs]="(catalogs$ | async) ?? []"
          [loading]="(loading$ | async) ?? false"
          [paginationOptions]="(paginationOptions$ | async) ?? undefined"
          [query]="queryParams.search"
          [sortBy]="queryParams.order_by"
          [sortDirection]="queryParams.direction"
          (queryChanged)="queryChanged($event)"
          (createCatalogRequested)="openCreateCatalog($event)"
          (deleteCatalogRequested)="openDeleteCatalog($event.catalog, $event.trigger)"></app-catalog-table>
      </se-fe-grid-cell>
    </se-fe-grid>
  </se-fe-card-content>
</se-fe-card>
